import { z } from 'zod';

const statementItemSchema = z.string().trim().min(1, 'Statement cannot be empty');

export const formConsentLocaleSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  consent_statement: z.string().min(1, 'Consent statement is required'),
  statements: z.array(statementItemSchema),
});

export const formConsentSchema = z.object({
  id: z.number().int().positive().optional(),
  is_default: z.boolean(),
  consent: z.object({
    i18n: z.object({
      en: formConsentLocaleSchema,
      es: formConsentLocaleSchema,
    }),
  }),
});

export type FormConsentInput = z.infer<typeof formConsentSchema>;
